import CryptoES from 'crypto-es'

interface Form {
    email: string
    password: string
    isRemember: boolean
}

export const encryptData = (Form: Form) => {
    const encrypted = CryptoES.AES.encrypt(
        JSON.stringify(Form),
        'Secret Passphrase'
    ).toString()
    return encrypted
}

export const decryptData = (encryptedData: string | null) => {
    if (!encryptedData) {
        return null // Return null if encryptedData is null or undefined
    }
    const decrypted = CryptoES.AES.decrypt(encryptedData, 'Secret Passphrase')
    const decryptedString = decrypted.toString(CryptoES.enc.Utf8)
    const decryptedObj = JSON.parse(decryptedString)
    return decryptedObj
}

export const getCookie = (name: string) => {
    const cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim()
        if (cookie.startsWith(`${name}=`)) {
            return decodeURIComponent(cookie.substring(name.length + 1))
        }
    }
    return null // Return null if cookie not found
}
